import { render } from "./video-category.vue?vue&type=template&id=69ca2bc0&scoped=true"
import script from "./video-category.vue?vue&type=script&lang=js"
export * from "./video-category.vue?vue&type=script&lang=js"

import "./video-category.vue?vue&type=style&index=0&id=69ca2bc0&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ca2bc0"]])

export default __exports__